export default function renderIcon({ width = "16", height = "16" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <path id="Icon_metro-notification" data-name="Icon metro-notification" d="M10.571,3.428a6.5,6.5,0,1,0,4.6,1.9A6.457,6.457,0,0,0,10.571,3.428Zm0-1.5a8,8,0,1,1-8,8,8,8,0,0,1,8-8Zm-1,11h2v2h-2Zm0-8h2v6h-2Z" transform="translate(-2.571 -1.928)" />
    </svg>
  )
}
